import persistStore from "redux-persist/es/persistStore";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import { eventsMutation, userAgentsMutation } from "./events/eventsMutation";
import { authApi } from "./auth/auth.api";
import { schoolAuthApi } from "./auth/school.auth.api";
import authReducer from "./auth/auth.slice";
import uploadPermissionsReducer from "./students/uploadPermissions.slice";
import omrUploadReducer from "./omrUpload/omrUpload.slice";
import {
  inviteCodeApi,
  tenantSearchApi,
  activationCodesAPI,
} from "./InviteCodes/inviteCodeMutation";
import {
  studentsPageStudentsMutation,
  studentsPageEventsMutation,
} from "./students/studentMutation.js";
import { uploadMutation } from "./uploads/uploadMutation";
import { exploreApi } from "./explore/explorePageMutation";
import { schoolsApi } from "./schools/schoolsMutation";
import { teamsApi, userAgentsApi } from "./teams/teamsMutation.js";
import { omrUploadApi } from "./omrUpload/omrUploadApi";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const apiReducers = [
  eventsMutation,
  userAgentsMutation,
  authApi,
  schoolAuthApi,
  inviteCodeApi,
  activationCodesAPI,
  tenantSearchApi,
  studentsPageStudentsMutation,
  studentsPageEventsMutation,
  uploadMutation,
  exploreApi,
  schoolsApi,
  teamsApi,
  userAgentsApi,
  omrUploadApi,
];

const reducers = combineReducers({
  auth: authReducer,
  uploadPermissions: uploadPermissionsReducer,
  omrUpload: omrUploadReducer,
  ...apiReducers.reduce(
    (acc, item) => ({ ...acc, [item.reducerPath]: item.reducer }),
    {}
  ),
});

const persistedReducer = persistReducer(persistConfig, reducers);

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: false,
  }).concat(apiReducers.map((item) => item.middleware));

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware,
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);
